<template>
  <h3 class="mb-3">Client Testimonials</h3>

  <div class="mb-4">
    <div class="d-flex align-items-center mb-2">
      <div class="flex-shrink-0">
        <img
          src="@/assets/images/user-48.jpg"
          class="rounded-circle"
          style="width: 40px; height: 40px"
          alt="user"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex flex-wrap gap-2 justify-content-between">
          <div>
            <h4 class="fs-15 mb-0 fw-semibold">Irene George</h4>
            <span class="fs-12">15m ago</span>
          </div>
          <div class="d-flex gap-1">
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
          </div>
        </div>
      </div>
    </div>
    <p style="line-height: 1.4; max-width: 518px">
      "Great service! Found exactly what I needed for my property, and the
      process was smooth and hassle-free."
    </p>
  </div>
  <div class="mb-4">
    <div class="d-flex align-items-center mb-2">
      <div class="flex-shrink-0">
        <img
          src="@/assets/images/user-49.jpg"
          class="rounded-circle"
          style="width: 40px; height: 40px"
          alt="user"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex flex-wrap gap-2 justify-content-between">
          <div>
            <h4 class="fs-15 mb-0 fw-semibold">Irene George</h4>
            <span class="fs-12">15m ago</span>
          </div>
          <div class="d-flex gap-1">
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
          </div>
        </div>
      </div>
    </div>
    <p style="line-height: 1.4; max-width: 518px">
      "Great service! Found exactly what I needed for my property, and the
      process was smooth and hassle-free."
    </p>
  </div>
  <div class="mb-4">
    <div class="d-flex align-items-center mb-2">
      <div class="flex-shrink-0">
        <img
          src="@/assets/images/user-50.jpg"
          class="rounded-circle"
          style="width: 40px; height: 40px"
          alt="user"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex flex-wrap gap-2 justify-content-between">
          <div>
            <h4 class="fs-15 mb-0 fw-semibold">Irene George</h4>
            <span class="fs-12">15m ago</span>
          </div>
          <div class="d-flex gap-1">
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
          </div>
        </div>
      </div>
    </div>
    <p style="line-height: 1.4; max-width: 518px">
      "Great service! Found exactly what I needed for my property, and the
      process was smooth and hassle-free."
    </p>
  </div>
  <div class="mb-4">
    <div class="d-flex align-items-center mb-2">
      <div class="flex-shrink-0">
        <img
          src="@/assets/images/user-51.jpg"
          class="rounded-circle"
          style="width: 40px; height: 40px"
          alt="user"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex flex-wrap gap-2 justify-content-between">
          <div>
            <h4 class="fs-15 mb-0 fw-semibold">Irene George</h4>
            <span class="fs-12">15m ago</span>
          </div>
          <div class="d-flex gap-1">
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
          </div>
        </div>
      </div>
    </div>
    <p style="line-height: 1.4; max-width: 518px">
      "Great service! Found exactly what I needed for my property, and the
      process was smooth and hassle-free."
    </p>
  </div>
  <div class="mb-4">
    <div class="d-flex align-items-center mb-2">
      <div class="flex-shrink-0">
        <img
          src="@/assets/images/user-52.jpg"
          class="rounded-circle"
          style="width: 40px; height: 40px"
          alt="user"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex flex-wrap gap-2 justify-content-between">
          <div>
            <h4 class="fs-15 mb-0 fw-semibold">Irene George</h4>
            <span class="fs-12">15m ago</span>
          </div>
          <div class="d-flex gap-1">
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
            <i class="ri-star-line text-warning fs-16"></i>
          </div>
        </div>
      </div>
    </div>
    <p style="line-height: 1.4; max-width: 518px">
      "Great service! Found exactly what I needed for my property, and the
      process was smooth and hassle-free."
    </p>
  </div>

  <nav aria-label="Page navigation example">
    <ul class="pagination mb-0 justify-content-center">
      <li class="page-item">
        <a class="page-link icon" href="#" aria-label="Previous">
          <i class="material-symbols-outlined">keyboard_arrow_left</i>
        </a>
      </li>
      <li class="page-item">
        <a class="page-link active" href="#">1</a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#">2</a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#">3</a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#">4</a>
      </li>
      <li class="page-item">
        <a class="page-link icon" href="#" aria-label="Next">
          <i class="material-symbols-outlined">keyboard_arrow_right</i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ClientTestimonials",
});
</script>
